'use client';

import * as stylex from '@stylexjs/stylex';
import { Dialog } from '@base-ui/react/dialog';
import { PageSectionsLandingHeroConversionForm } from '@/tina/__generated__/types';
import { motion } from 'motion/react';
import { use } from 'react';
import '../../styles/tokens.stylex';
import { color, spacing } from '../../styles/tokens.stylex';
import { typography } from '../../styles/typography';
import { Button } from '../Buttons';
import { FormActionStateContext } from '../Form/FormBuilder';
import { StepsContext } from '../Form/StepsProvider';
import { tinaField } from 'tinacms/react';
const TEST_SUCCESS_STEP = false;
type SteppedFormHeaderProps = {
  data: PageSectionsLandingHeroConversionForm;
};
export function SteppedFormHeader({
  data
}: SteppedFormHeaderProps) {
  const {
    actionState
  } = use(FormActionStateContext);
  const ctx = use(StepsContext);
  const isSuccessStep = TEST_SUCCESS_STEP || actionState.result === 'success';
  const isMeetingAside = ctx?.isMeetingAside ?? false;
  const title = isSuccessStep ? 'Quote Request Submitted' : isMeetingAside ? 'Book a meeting' : data.headingOverride || data.form?.heading;
  return <div className="x1o4oh2x x1mmg668 x6s0dn4 x78zum5 x1qughib x1eiixza x1q0q8m5 xlxy82">
      <motion.div layout layoutId="conversion-form-heading-wrapper" className="x3ybb33 xrvj5dj">
        <motion.h1 layout layoutId="conversion-form-heading" {...stylex.props(typography.heading2)} transition={{
        inherit: true
      }} data-tina-field={tinaField(data, data.headingOverride ? 'headingOverride' : 'form')}>
          {title}
        </motion.h1>
      </motion.div>
      <Dialog.Close render={<Button iconOnly="x" variant="ghost" theme="neutral" size="compact" />} />
    </div>;
}